import { OtpVerify } from '../api/auth';
import { API_URL } from '../config';
import axios from 'axios';
import LoginPassword from '../pages/auth/LoginPassword';
import Onboarding from '../pages/Onboarding';
import { get, update } from 'lodash';
import { stripEmojisDeep } from './emoji';

const axiosInstance = axios.create({ baseURL: API_URL });
const SOURCE_DETAILS = {
  platform: 'web',
  product: 'spandan-one',
};
/**
 * The backend retires every token minted before a member's password changed, so
 * an open session can stop being valid without this tab doing anything wrong.
 * It answers those requests with 401 + code SESSION_EXPIRED, and the app has to
 * log out rather than leave a signed-in shell that fails every call.
 *
 * Logging out is App's job (it owns the auth context, the socket and analytics),
 * but this module is plain JS outside React, so App registers its handler here
 * on mount instead of this file reaching into the tree.
 */
const SESSION_EXPIRED = 'SESSION_EXPIRED';
let onSessionExpired = null;
let sessionExpiryHandled = false;

export const setSessionExpiredHandler = (handler) => {
  onSessionExpired = handler;
};

/** Cleared on login so a later expiry in the same tab is handled again. */
export const resetSessionExpiredGuard = () => {
  sessionExpiryHandled = false;
};

axiosInstance.interceptors.request.use(
  (config) => {
    try {
      config.headers['source_details'] = JSON.stringify(SOURCE_DETAILS);
    } catch (e) {
      config.headers['source_details'] = '{"platform":"web","product":"spandan-one"}';
    }

    // Emojis are never sent to the backend, whichever screen built the payload.
    config.data = stripEmojisDeep(config.data);
    config.params = stripEmojisDeep(config.params);

    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const data = error?.response?.data;

    // Only this code, never a bare 401 - a wrong password on the login screen
    // is also a 401 and must stay on that screen showing its own error.
    if (error?.response?.status === 401 && data?.code === SESSION_EXPIRED) {
      // Several calls usually fail together on the same expired token; the
      // first one logs out and the rest must not repeat it.
      if (!sessionExpiryHandled) {
        sessionExpiryHandled = true;
        onSessionExpired?.(data.message);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
export const poster = async (url, body, method = 'POST') => {
  try {
    const response = await axiosInstance.post(url, body);
    return response.data;
  } catch (error) {
    console.error('Request error:', error);
    throw error;
  }
};

export const posterForm = async (url, body, method = 'POST') => {
  try {
    const config = {
      method,
      url,
      data: body,
      headers: {},
    };

    // Automatically set headers if body is FormData
    if (body instanceof FormData) {
      config.headers['Content-Type'] = 'multipart/form-data';
    }

    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const fetcher = async (url, body, method = 'POST') => {
  try {

    const response = await axiosInstance.post(url, body);
    return response.data;
  } catch (error) {
    console.error('Request error:', error);
    throw error;
  }
};

export const setsession = (token) => {
  axiosInstance.defaults.headers.common['Authorization'] = `${token}`;
}

export const fetcherGET = async (url, { params } = {}) => {
  try {
    const headers = {
      "Content-Type": "application/json",
    };

    const response = await axiosInstance.get(url, { params, headers });
    return response.data;
  } catch (error) {
    console.error("GET request error:", error);
    throw error;
  }
};



export const fetcherSwr = async (args) => {
  try {
    // if (axiosInstance.defaults.headers.common['auth']) {
    const [url, config] = Array.isArray(args) ? args : [args];
    const res = await axiosInstance.get(url, { ...config });
    return res.data;
    // } else {
    //   return {result:false, data : [ ]}
    // }
  } catch (e) {
    throw e;
  }
};


// export const deleter = async (url) => {
//   try {
//     const response = await axiosInstance.delete(url);
//     return response.data;
//   } catch (error) {
//     console.error('Request error:', error);
//     throw error;
//   }
// };

export const deleter = async (url, config = {}) => {
  try {
    const response = await axiosInstance.delete(url, config);
    return response.data;
  } catch (error) {
    console.error('Request error:', error);
    throw error;
  }
};

export const patcher = async (url, body) => {
  try {
    const response = await axiosInstance.patch(url, body);
    return response.data;
  } catch (error) {
    console.error('Request error:', error);
    throw error;
  }
}



const appPrefix = process.env.REACT_APP_PREFIX
const abhaPrefix = process.env.REACT_APP_ABHA_PREFIX;

const authPrefix = appPrefix + '/v1/auth';
const centerPrefix = appPrefix + '/v1/centers';
const businessPrefix = appPrefix + '/v1/businesses';
const collectionPrefix = appPrefix + '/v1/test-collections';
const reportPrefix = appPrefix + '/v1/reports';
const casesPrefix = appPrefix + '/v1/cases';
const analyticsPrefix = appPrefix + '/v1/analytics';
const analyticsExportPrefix = appPrefix + '/v1/analytics-export';
const consultPrefix = appPrefix + '/v1/online-consultation';
const patientPrefix = appPrefix + '/v1/patients';
const symptomsPrefix = appPrefix + '/v1/symptoms';
const interpretationPrefix = appPrefix + '/v1/interpretations';
const orgsetting = appPrefix + '/v1/organizations';
const notificationPrefix = appPrefix + '/v1/notifications';
const workspacesPrefix = appPrefix + '/v1/workspaces';
const webhookPrefixe = appPrefix + '/v1/webhooks';
const screeningPrefix = appPrefix + '/v1/screening';
const facilityPrefix = appPrefix + '/v1/facilities';
const migrationPrefix = appPrefix + '/v1/migration';
const creditsPrefix = appPrefix + '/v1/credits';
const devicePrefix = appPrefix + '/v1/devices';
// const prefix = 'v1/user/';
// const prefixAnalytics ='v1/spandan-one-analytics/';
// const prefixCollection = 'v1/collection/';
// const prefixReport = 'v1/report/';
// const prefixFaqs = 'v1/user/';
export const endpoints = {
  auth: {
    login: `${authPrefix}/login`,
    OtpVerify: `${authPrefix}/verify`,
    LoginPassword: `${authPrefix}/verify`,
    VerifyToken: `${authPrefix}/reverify`,
    Logout: `${authPrefix}/logout`,
    Registerfcmtoken: `${authPrefix}/register-fcm-token`,
    sendOtp: `${authPrefix}/whatsapp-otp`,
  },
  migration: {
    syncReports: `${migrationPrefix}/sync-reports`,
  },
  ecg: {
    getEcgList: `${reportPrefix}/`,
    getEcgDetails: `${reportPrefix}/details/`,
    getEcgGraph: `${reportPrefix}/graph/`,
    requestInterpretation: `${reportPrefix}/interpretation/request`,
    exportReports: `${reportPrefix}/export`,

  },
  collection: {
    getCollection: `${collectionPrefix}/`,
    getCollectionDetails: `${collectionPrefix}/`,
    getAssignees: `${collectionPrefix}/assignees`,
    searchPatient: `${patientPrefix}/`,
    getPatient: `${patientPrefix}/`,
    getPatientsList: `${patientPrefix}/list`,
    toggleStarPatient: `${patientPrefix}/`,
    createCollection: `${collectionPrefix}/`,
    deleteCollection: `${collectionPrefix}/`,
    fetchSymptoms: `${symptomsPrefix}/`,
    updateCollection: `${collectionPrefix}/`,
    createPatient: `${patientPrefix}/`,
    updatePatient: `${patientPrefix}/`,
  },
  settings: {
    getCentres: `${centerPrefix}/`,
    checkLegacyClinic: `${centerPrefix}/migration/has-clinic`,
    removeCenter: `${centerPrefix}/`,
    addMember: `${businessPrefix}/member/assign`,
    updateMember: `${businessPrefix}/member`,
    getPeople: `${businessPrefix}/member`,
    getPeoples: `${businessPrefix}/members`,
    getPeopleDetails: `${businessPrefix}/members`,
    changeCentre: `${centerPrefix}/change`,
    AddCenter: `${centerPrefix}/`,
    updateCenter: `${centerPrefix}/`,
    getSpecificCenter: `${centerPrefix}`,
    updateAdminProfile: `${orgsetting}/profile`,
    removeMember: `${businessPrefix}/member`,
    updateGenralSetting: `${businessPrefix}/settings`,
    getGenralSetting: `${businessPrefix}/settings`,
    getProfile: `${businessPrefix}/profile`,
    getSubscriptionLogs: `${businessPrefix}/subscription-logs`,
    getWorkSpace: `${workspacesPrefix}/`,
  },
  credits: {
    createTopUpOrder: `${creditsPrefix}/topup/order`,
    verifyTopUpPayment: `${creditsPrefix}/topup/verify`,
    getPurchaseHistory: `${creditsPrefix}/topup/history`,
    downloadInvoice: (id) => `${creditsPrefix}/topup/invoice/${id}`,
  },
  Onboarding: {
    userOnboarding: `${businessPrefix}/`,
    memberOnboarding: `${businessPrefix}/member`
  },
  analytics: {
    getInsights: `${analyticsPrefix}/`,
    // Split halves of getInsights: the fast summary counters and the slow
    // interpretation facet, fetched separately so the cards paint first.
    getInsightsSummary: `${analyticsPrefix}/summary`,
    getInsightsInterpretation: `${analyticsPrefix}/interpretation`,
    getTimeseries: `${analyticsPrefix}/timeseries`,
  },
  analyticsExport: {
    getTables: `${analyticsExportPrefix}/tables`,
  },
  onlineConsultation: {
    getToken: `${consultPrefix}/token`,
  },
  interpretations: {
    getInterpretations: `${interpretationPrefix}/`,
    getInterpretationsDetails: `${interpretationPrefix}/`,
    setInterpretationsInvite: `${interpretationPrefix}/invite/`,
    // setCloseInterpretations: `${interpretationPrefix}/`,

    getEcgData: `${interpretationPrefix}/get-ecg-data/`,
    setInterpretation: `${interpretationPrefix}/save-interpretation-data`,
  },
  cases: {
    getCases: `${casesPrefix}/`,
    getCaseDetails: `${casesPrefix}/`,
    setCaseInvite: `${casesPrefix}/invite/`,
    setCloseCase: `${casesPrefix}/`,
    acceptReferral: `${casesPrefix}/:id/accept`,
    rejectReferral: `${casesPrefix}/:id/reject`,
    // Patient journey - the backend owns the workflow graph, this app renders it.
    getCaseJourney: (reportId) => `${casesPrefix}/${reportId}/journey`,
    submitJourneyStep: (reportId) => `${casesPrefix}/${reportId}/journey/steps`,
    undoJourneyStep: (reportId, entryId) =>
      `${casesPrefix}/${reportId}/journey/steps/${entryId}`,
  },
  helpcenter: {
    faqs: `${businessPrefix}/faqs`,
  },
  registries: {
    addRegistry: `${appPrefix}/v1/registries`,
    viewRegistry: `${appPrefix}/v1/registries`,
  },

  abha: {
    searchAbhaPhone: `${abhaPrefix}/search-abha-login`,
    abhaLogin: `${abhaPrefix}/abha-login`,
    loginOtpVerify: `${abhaPrefix}/login-otp-verify`,
    getAbhaProfile: `${abhaPrefix}/get-abha-profile`,
    getAbhaAuthMethods: `${abhaPrefix}/get-auth-methods`,
    abhaLoginUsingAddress: `${abhaPrefix}/user-login-abha-address`,
    abhaAddressOtpVerify: `${abhaPrefix}/login-abha-address-otp-verify`,
    createAbha: `${abhaPrefix}/abha-signup`,
    abhaCreateOtpVerify: `${abhaPrefix}/abha-signup-otp-verify`,
    createAbhaAddress: `${abhaPrefix}/create-abha-address`,
    createAbhaConsent: `${abhaPrefix}/consent-request`,
    getAbhaConsent: `${abhaPrefix}/consent-request`,
    getConsentData: `${abhaPrefix}/consent-granted`,
    downloadReportFile: `${abhaPrefix}/get-pushed-pdf`,

  },
  organisation: {
    getOrgSettings: `${orgsetting}/profile`,
    updateOrgProfile: `${orgsetting}/profile`,
  },
  notifications: {
    getNotifications: `${notificationPrefix}/`,
    closeNotification: `${notificationPrefix}/close`,

  },
  items: {
    getItems: `${interpretationPrefix}/teams`,
  },
  webhook: {
    webhooks: `${webhookPrefixe}/`,
    deleteWebhook: `${webhookPrefixe}/:id`,
    updateWebhook: `${webhookPrefixe}/:id`,
    createWebhook: `${webhookPrefixe}/`,
  },
  ftp: {
    getOrg: `${appPrefix}/v1/ftp/settings/organization`,
    getCenters: `${appPrefix}/v1/ftp/settings/centers`,
    reveal: (apiKey) => `${appPrefix}/v1/ftp/settings/reveal/${apiKey}`,
    update: (apiKey) => `${appPrefix}/v1/ftp/settings/${apiKey}`,
  },
  screening: {
    getScreenings: `${screeningPrefix}/`,
  },
  facilities: {
    getFacilities: `${facilityPrefix}/`,
    createFacility: `${facilityPrefix}/`,
    updateFacility: (id) => `${facilityPrefix}/${id}`,
    deleteFacility: (id) => `${facilityPrefix}/${id}`,
  },
  devices: {
    getDevices: `${devicePrefix}/`,
    
  }
};
